import { __awaiter } from "tslib";
import replaceAll from '../common/replaceAll';
const NAME_STYLES = {
    SHORT: 'short',
    FORMAL: 'formal',
};
const NAME_PATTERNS = {
    TITLE: '{title}',
    FIRST_NAME: '{firstName}',
    MIDDLE_NAME: '{middleName}',
    LAST_NAME: '{lastName}',
    ALTERNATIVE_FIRST_NAME: '{alternativeFirstName}',
    ALTERNATIVE_LAST_NAME: '{alternativeLastName}',
};
const DEFAULT_NAME_FORMAT = NAME_PATTERNS.FIRST_NAME;
const formatName = (getFormatters) => (name, nameStyle = NAME_STYLES.SHORT) => __awaiter(void 0, void 0, void 0, function* () {
    const formattingPatterns = getFormatters();
    const namePatterns = formattingPatterns.nameFormatter || {};
    const nameFormat = (nameStyle === NAME_STYLES.FORMAL && namePatterns
        ? namePatterns.formalName
        : namePatterns.salutationName) || DEFAULT_NAME_FORMAT;
    return replaceAll(nameFormat, {
        [NAME_PATTERNS.TITLE]: name.title || '',
        [NAME_PATTERNS.FIRST_NAME]: name.firstName || '',
        [NAME_PATTERNS.MIDDLE_NAME]: name.middleName || '',
        [NAME_PATTERNS.LAST_NAME]: name.lastName || '',
        [NAME_PATTERNS.ALTERNATIVE_FIRST_NAME]: name.alternativeFirstName || '',
        [NAME_PATTERNS.ALTERNATIVE_LAST_NAME]: name.alternativeLastName || '',
    });
});
export default formatName;
//# sourceMappingURL=formatName.js.map